module.exports = __webpack_public_path__ + "img/oldcreative-logo.fbaab9fa.png";